<template>
  <div class="column is-one-third-desktop is-half-tablet">
    <div class="box has-text-centered">
      <div class="columns" style="margin-bottom: 0;">
        <div class="column has-text-left">
          {{
            moment
              .utc(feedback.createdAt)
              .add(preferences.timezone, "h")
              .format("DD/MM/YY HH:mm:ss")
          }}
          <br />
          <b>{{ feedback.store.storeInfo.name }}</b>
        </div>

        <div class="column is-narrow">
          <b-dropdown
            class="is-pulled-right"
            :triggers="['hover']"
            aria-role="list"
            position="is-bottom-left"
          >
            <template #trigger>
              <b-button
                class="button is-pulled-right"
                :class="
                  feedback.status === 'new' || feedback.status === undefined
                    ? 'is-primary'
                    : feedback.status === 'pending'
                    ? 'is-warning'
                    : feedback.status === 'resolved'
                    ? 'is-success'
                    : 'is-light'
                "
                slot="trigger"
                @click.stop
              >
                {{
                  feedback.status === "new" || feedback.status === undefined
                    ? $t("feedback.new")
                    : feedback.status === "pending"
                    ? $t("feedback.pending")
                    : feedback.status === "resolved"
                    ? $t("feedback.resolved")
                    : $t("common.questionMark")
                }}
              </b-button>
            </template>

            <b-dropdown-item
              aria-role="listitem"
              v-if="
                permissions.changeFeedbackStatus &&
                  feedback.status !== 'new' &&
                  feedback.status !== undefined
              "
            >
              <button
                class="button is-small"
                :style="{
                  backgroundColor: $primaryColor,
                  color: $primaryColorContrast
                }"
                @click.stop="changeFeedbackStatus('new')"
              >
                {{ $t("feedback.markAsNew") }}
              </button>
            </b-dropdown-item>

            <b-dropdown-item
              aria-role="listitem"
              v-if="
                permissions.changeFeedbackStatus &&
                  feedback.status !== 'pending'
              "
            >
              <button
                class="button is-warning is-small"
                @click.stop="changeFeedbackStatus('pending')"
              >
                {{ $t("feedback.markAsPending") }}
              </button>
            </b-dropdown-item>

            <b-dropdown-item
              aria-role="listitem"
              v-if="
                permissions.changeFeedbackStatus &&
                  feedback.status !== 'resolved'
              "
            >
              <button
                class="button is-success is-small"
                @click.stop="changeFeedbackStatus('resolved')"
              >
                {{ $t("feedback.markAsResolved") }}
              </button>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
      <hr class="has-background-primary" style="margin-top: 0;" />

      <star-rating
        v-if="feedback.rating"
        :rating="feedback.rating"
        :show-rating="false"
        :star-size="40"
        :inline="true"
        :read-only="true"
      />

      <div
        v-if="
          feedback.user &&
            feedback.user.accountInfo &&
            feedback.user.accountInfo.isTotemAccount
        "
      >
        <p>Totem: {{ feedback.user._id }}</p>
      </div>

      <div v-else-if="feedback.user">
        <div v-if="permissions.seeStoreClientName">
          <p>
            {{ feedback.user.personalInfo.name }}
            {{
              permissions.seeStoreClientSurname
                ? ` ${feedback.user.personalInfo.surname}`
                : ""
            }}
          </p>

          <p v-if="feedback.user.personalInfo.socialName">
            {{
              `${$t("common.socialName")}: ${
                feedback.user.personalInfo.socialName
              }`
            }}
          </p>
        </div>

        <p v-else>
          <b>{{ $t("feedback.client") }}:</b>
          {{ feedback.user._id }}
        </p>

        <p v-if="permissions.seeStoreClientEmail">
          <a
            :href="`mailto:${feedback.user.personalInfo.email}`"
            target="_blank"
          >
            {{ feedback.user.personalInfo.email }}
          </a>
        </p>

        <p v-if="permissions.seeStoreClientCellphone">
          <a
            :href="
              `https://wa.me/${cellphoneWithCountryCallingCode(
                feedback.user.personalInfo
              ).replace(/\D/g, '')}`
            "
            target="_blank"
          >
            {{ cellphoneWithCountryCallingCode(feedback.user.personalInfo) }}
            <img
              src="../../assets/img/logo-whatsapp.png"
              alt=""
              style="position: relative; top: 4px; left: 4px;"
            />
          </a>
        </p>
      </div>

      <p v-else-if="feedback.vending">
        {{ feedback.vending.vendingInfo.name }}
      </p>
      <br />

      <div class="box has-background-light" v-if="feedback.message">
        <p class="comment-wrapper">
          <span class="comment">
            {{ $t("feedback.comment") }}
          </span>
        </p>

        {{ feedback.message }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "../../mixins/mask";
import starRating from "vue-star-rating";

export default {
  props: ["feedback"],

  mixins: [mask],

  components: {
    starRating
  },

  methods: {
    changeFeedbackStatus(status) {
      this.$emit("change-feedback-status", {
        feedbackId: this.feedback._id,
        status
      });
    }
  },

  computed: {
    ...mapGetters(["permissions", "preferences"])
  }
};
</script>

<style scoped>
.comment-wrapper {
  position: relative;
  width: 0;
  height: 0;
}
.comment {
  position: absolute;
  top: -32px;
  left: -14px;
  font-weight: 600;
  font-size: 0.9rem;
}
</style>
